/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';
import type { IActiveUserProfile } from 'ajs/modules/core/services/active-user-profile';

const USER_PROFILE_SOURCE = '[User Profile]';

export const setUserProfile = createAction(
    `${USER_PROFILE_SOURCE} Set User Profile`,
    props<{ payload: IActiveUserProfile }>(),
);
